import { Routes } from '@angular/router';
import { AuthGuard } from '../core/services/auth-guard.service';
import { HydraErrorPageComponent } from './components/hydra-error-page/hydra-error-page.component';
import { CallbackComponent } from './components/callback/callback.component';
import { RedirectCallbackComponent } from './components/callback/redirect-callback.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ResetPasswordSuccessComponent } from './components/reset-password/reset-password-success/reset-password-success.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { OauthComponent } from './containers/oauth.component';
import { ChallengeExpiryComponent } from './components/challenge-expiry/challenge-expiry.component';
import { OpenidCallbackComponent } from './components/openid-callback/openid-callback.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { TwoFactorLoginComponent } from './components/two-factor-login/two-factor-login.component';
export const oAuthRoutes: Routes = [
  {
    path: 'auth',
    component: OauthComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: LoginComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'forgot',
        component: ForgotPasswordComponent,
       canActivate: [AuthGuard],
      },
      {
        path: 'mfa',
        component: TwoFactorLoginComponent,
        canActivate: [AuthGuard],
       
      },
      {
        path: 'logout',
        component: LogoutComponent
      },
      {
        path: 'error',
        component: HydraErrorPageComponent
      },
       {
        path: 'reset',
        component: ResetPasswordComponent
      },
      {
        path: 'reset-success',
        component: ResetPasswordSuccessComponent
      },
      {
        path: 'callback',
        component: CallbackComponent
      },
      {
        path: 'redirect-callback',
        component: RedirectCallbackComponent
      },
      {
        path: 'openid-callback',
        component: OpenidCallbackComponent
      },
      {
        path: 'challenge-expiry',
        component: ChallengeExpiryComponent
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent
      }
    ]
  }
];
